
import { Facebook, Instagram, Linkedin } from "lucide-react";

interface SocialIconsProps {
  className?: string;
  iconSize?: number;
}

const SocialIcons = ({ className = "", iconSize = 24 }: SocialIconsProps) => {
  const iconCls =
    "w-10 h-10 inline-flex items-center justify-center rounded-full border-[1.5px] border-primary text-primary bg-white transition-all duration-200 ease-[ease] hover:bg-primary hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2";
  return (
    <div className={`flex space-x-3 ${className}`}>
      <a
        href="https://www.facebook.com/profile.php?id=61575010856485"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Seguir en Facebook"
        className={iconCls}
      >
        <Facebook size={iconSize} aria-hidden="true" />
      </a>
      <a
        href="https://www.instagram.com/nexushr.cr/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Seguir en Instagram"
        className={iconCls}
      >
        <Instagram size={iconSize} aria-hidden="true" />
      </a>
      <a
        href="https://www.linkedin.com/company/nexus-hr-costa-rica/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Seguir en LinkedIn"
        className={iconCls}
      >
        <Linkedin size={iconSize} aria-hidden="true" />
      </a>
    </div>
  );
};

export default SocialIcons;
